function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.033 4.163a8.703 8.703 0 012.55-2.701C18.957.522 20.553 0 22.146 0 26.402 0 30 3.986 30 8.595c0 5.821-2.8 10.35-7.41 13.698a25.855 25.855 0 01-4.99 2.816c-.596.256-1.15.468-1.65.64-.306.105-.53.175-.658.21a1.082 1.082 0 01-.584 0 12.866 12.866 0 01-.658-.21c-.5-.172-1.054-.384-1.65-.64a25.908 25.908 0 01-4.99-2.816C2.8 18.946 0 14.416 0 8.595 0 3.869 3.38 0 7.854 0a8.247 8.247 0 017.18 4.163z",
  fill: "#FFF"
});
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b8017350.svg";
export { ForwardRef as ReactComponent };